import React from 'react';
import './index.css'

const Item = (props) => (
    <div className="item-container-inner">
        <div className="circle">
            <img className="item-icon" src={props.icon} alt=""/>
        </div>
        <h3>{props.title}</h3>
        <p className="item-desc-seperator"></p>
        <p>{props.description}</p>
    </div>
)
export default Item;